// src/core/companySettings/companySettingsStore.js
import { companySettingsApi } from './index';
import { tokenStorage } from 'shared/api/storage';

const LS_KEY = 'solis:companySettings:v1';

let state = {
  loading: false,
  error: null,
  settings: null,
};

const listeners = new Set();

function emit() {
  for (const fn of listeners) fn();
}

function setState(patch) {
  state = { ...state, ...patch };
  emit();
}

function readCache() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.value ?? null;
  } catch {
    return null;
  }
}

function writeCache(value) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify({ ts: Date.now(), value }));
  } catch {
    // ignore
  }
}

function clearCache() {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    // ignore
  }
}

function isPublicPath(pathname) {
  return (
    pathname.startsWith('/rsvp/') ||
    pathname === '/sign-in' ||
    pathname === '/sign-up' ||
    pathname === '/forgot-password' ||
    pathname === '/verify-email' ||
    pathname === '/login' ||
    pathname === '/register'
  );
}

async function fetchFromApi() {
  // ✅ public sayfalarda company-settings çekme
  const p = window.location.pathname || '';
  if (isPublicPath(p)) {
    // burada loading bile yapmıyorum, sessizce çıkıyorum
    return state.settings ?? null;
  }

  // ✅ token yoksa API’ye gitme
  const tokens = tokenStorage.get();
  if (!tokens?.accessToken) {
    // istersen settings’i temizle:
    // setState({ settings: null, loading: false, error: null });
    return null;
  }

  setState({ loading: true, error: null });
  try {
    const res = await companySettingsApi.getMy();
    const value = res?.data ?? res ?? null;

    writeCache(value);
    setState({ settings: value, loading: false, error: null });
    return value;
  } catch (e) {
    setState({ loading: false, error: e?.message || 'Company settings yüklenemedi.' });
    throw e;
  }
}

function hydrateFromCacheIfEmpty() {
  if (state.settings) return;
  const cached = readCache();
  if (cached) setState({ settings: cached });
}

export const companySettingsStore = {
  getSnapshot() {
    return state;
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  hydrateFromCacheIfEmpty,
  fetchFromApi,

  async refresh() {
    // ✅ public sayfalarda refresh de yapma
    const p = window.location.pathname || '';
    if (isPublicPath(p)) return state.settings ?? null;

    // ✅ token yoksa refresh yapma
    const tokens = tokenStorage.get();
    if (!tokens?.accessToken) return null;

    clearCache();
    return fetchFromApi();
  },

  set(value) {
    writeCache(value);
    setState({ settings: value, error: null });
  },

  clearCache,
};
